<template>
  <div class="content-contents container-fluid">
    <naj-box
      :title="local.secondHeader.profilePage"
      header-icon="mdi-account"
      header-class="main-header"
      disable-collapsing
    >
      <profile-details
        :is-profile="true"
        :show-modify-mobile="true"
        :user-object="profileData"
        @onClose="loadData"
      ></profile-details>
    </naj-box>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import ProfileDetails from './profile-details.vue';
const { mapActions: mapComplaintsActions } = createNamespacedHelpers('ComplaintsModule');

export default {
  name: 'Profile',
  components: { ProfileDetails },
  props: {},
  data() {
    return { profileData: {} };
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() { this.loadData(); },
  methods: {
    ...mapComplaintsActions([
      'getComplainantData',
    ]),
    loadData() {
      this.loading = true;
      this.getComplainantData()
        .then((data) => {
          this.profileData = data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
